import React from 'react';
import Header from '../Header';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

const ThanksContainer = styled.div`
  width:100%;
padding-top:40px;
  display:flex;
  flex-direction:column;
  justify-content: space-between;
  text-align:center;
  margin-bottom: 40px;
  margin-left: 20px;
  row-gap: 20px;
  align-items:center ;
  padding-bottom:40px;

  & h2{
    width:100%;
    margin-right:0;

  }


   & p {
    width:50%;
   }
  

  
`;





const Thanks = () => {
    const navigate = useNavigate();


    const { i18n } = useTranslation('common');

    function gotoevent() {

        navigate('/evenements')
    }

    return (
        <div>
            <Header />
            <ThanksContainer>
                {i18n.language === "fr" ? <>
                    <h2>Merci pour votre inscription</h2>
                    <p>Un email de confirmation vous a été envoyé sur votre adresse email.
                    Vous avez la possibilité de modifier vos réponses jusqu'au jeudi 29 février 2024 à minuit, en vous
                    connectant sur votre compte à partir du site connected by lefrenchdesign.org ou via le mail de
                    confirmation que vous avez reçu. (vérifiez dans vos spams)</p>
                </> : <>
                    <h2>THANK YOU FOR REGISTERING</h2>
                    <p>If you have any problems with your registration, please send an email
                    detailing your problem to the following address: boury@via.fr, we will get back to you
                    quickly. For emergencies, contact Constane Boury by email on boury@via.fr or by phone on
                    +33144681814 (Monday to Friday - 10am to 5pm)</p>
                </>}
                <button onClick={gotoevent}>{i18n.language === "fr" ? 'Mes évènements' : 'My events'}</button>
            </ThanksContainer>

        </div>
    );
};

export default Thanks;